import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.Save.IRequest;
type Response = Api.Finance.AccountReceivable.Save.IResponse;
type Headers = Api.Finance.AccountReceivable.Save.IHeaders;
const url = '/api/Finance/AccountReceivable';
export default async function accountReceivableSaveApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
